import { useEffect } from 'react'

function clean(value) { return String(value || '').replace(/\s+/g, ' ').trim() }

function route() { return (window.location.hash.replace(/^#/, '') || '/').split('?')[0] }

function ensureDirectorAssetFields() {
  if (!/^\/directors\/[^/]+$/.test(route())) return
  const root = document.querySelector('.admin-content')
  if (!root) return
  const serviceTab = [...root.querySelectorAll('.tabs button')].find((button) => clean(button.textContent) === '서비스·프로필')
  if (!serviceTab?.classList.contains('active')) return
  if (root.querySelector('[data-field-parity-director-assets]')) return

  const serviceCard = [...root.querySelectorAll('.card')].find((card) => clean(card.querySelector('.card-header h2')?.textContent) === '서비스 상세')
  if (!serviceCard) return

  const card = document.createElement('section')
  card.className = 'card'
  card.dataset.fieldParityDirectorAssets = 'true'
  card.innerHTML = `
    <header class="card-header"><div><h2>공개 이미지 필드</h2><p>디렉터 센터 기본 프로필의 이미지 등록 필드와 동일한 단위로 조회합니다.</p></div></header>
    <div class="card-body">
      <dl class="definition-list">
        <div><dt>프로필 사진</dt><dd>profileImage</dd></div>
        <div><dt>상세 상단 대표 이미지</dt><dd>coverImage</dd></div>
        <div><dt>사진 자료</dt><dd>mediaImages[]</dd></div>
      </dl>
      <p class="admin-long-text" style="margin-top:12px">실제 DB/API에서는 각 파일의 object key, 파일명, MIME type, 크기와 공개용 URL/변환본을 미디어 원장으로 연결합니다.</p>
    </div>
  `
  serviceCard.insertAdjacentElement('afterend', card)
}

function apply() { ensureDirectorAssetFields() }

export default function AdminFieldStructureParityEnhancer() {
  useEffect(() => {
    let queued = false
    const schedule = () => {
      if (queued) return
      queued = true
      queueMicrotask(() => { queued = false; apply() })
    }
    apply()
    const observer = new MutationObserver(schedule)
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] })
    window.addEventListener('hashchange', schedule)
    return () => { observer.disconnect(); window.removeEventListener('hashchange', schedule) }
  }, [])
  return null
}
